/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Seniority_MidInputs */

const en_salary_seniority_mid = /** @type {(inputs: Salary_Seniority_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mid`)
};

const de_salary_seniority_mid = /** @type {(inputs: Salary_Seniority_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittel`)
};

const fr_salary_seniority_mid = /** @type {(inputs: Salary_Seniority_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intermédiaire`)
};

const es_salary_seniority_mid = /** @type {(inputs: Salary_Seniority_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intermedio`)
};

const it_salary_seniority_mid = /** @type {(inputs: Salary_Seniority_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mid`)
};

const nl_salary_seniority_mid = /** @type {(inputs: Salary_Seniority_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mid`)
};

const pl_salary_seniority_mid = /** @type {(inputs: Salary_Seniority_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mid`)
};

const fi_salary_seniority_mid = /** @type {(inputs: Salary_Seniority_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keskitaso`)
};

const da_salary_seniority_mid = /** @type {(inputs: Salary_Seniority_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mellemniveau`)
};

const sv_salary_seniority_mid = /** @type {(inputs: Salary_Seniority_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mellannivå`)
};

/**
* | output |
* | --- |
* | "Mid" |
*
* @param {Salary_Seniority_MidInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_seniority_mid = /** @type {((inputs?: Salary_Seniority_MidInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Seniority_MidInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_seniority_mid(inputs)
	if (locale === "fr") return fr_salary_seniority_mid(inputs)
	if (locale === "es") return es_salary_seniority_mid(inputs)
	if (locale === "it") return it_salary_seniority_mid(inputs)
	if (locale === "nl") return nl_salary_seniority_mid(inputs)
	if (locale === "pl") return pl_salary_seniority_mid(inputs)
	if (locale === "fi") return fi_salary_seniority_mid(inputs)
	if (locale === "da") return da_salary_seniority_mid(inputs)
	if (locale === "sv") return sv_salary_seniority_mid(inputs)
	return en_salary_seniority_mid(inputs)
});